import axios from "axios";
import Vue from "vue";
import authHeader from "@/services/auth-header";
import config from "@/data/config";
import model from "@/data/model";

const API_URL = config.baseURL;
const myModel = model.umat;

// function createOptions(data) {
//    return data.map((item) => {
//       return { text: item, value: item };
//    });
// }
function createOptions(data) {
   return data.map((item) => {
      return { text: item, value: item };
   });
}

export const umat = {
   namespaced: true,
   state: {
      data: [],
      item: { ...myModel },
      suami: { ...myModel },
      istri: { ...myModel },
   },
   getters: {
      // countAll: (state) => {return state.data.length},
      countAll(state) {
         return state.data.length;
      },
      getById: (state) => (id) => {
         return state.data.find((data) => data.id === id);
      },
   },
   actions: {
      async getAll({ commit, rootState }) {
         rootState.isLoading = true;
         await axios
            .get(`${API_URL}data_umat`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_DATA", response.data);
                  rootState.isLoading = false;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      async getAllRemote({ commit, rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}data_umat/remote`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_DATA", response.data);
                  rootState.isLoading = false;
                  return response.data;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      async getItem({ rootState }, id) {
         rootState.isLoading = true;
         return await axios
            .get(`${API_URL}data_umat/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async insert({ rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}data_umat`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  // commit("PUSH_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async update({ rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .put(`${API_URL}data_umat/${data.umat.uid}`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  // commit("CHANGE_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async delete({ rootState }, id) {
         rootState.isLoading = true;
         return await axios
            .delete(`${API_URL}data_umat/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  // commit("REMOVE_ITEM", id);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      setItem({ commit }, item) {
         commit("SET_ITEM", item);
      },
      setItemForm({ commit }, item) {
         commit("SET_ITEM_FORM", item);
      },
      setItemSuami({ commit }, item) {
         commit("SET_ITEM_SUAMI", item);
      },
      setItemIstri({ commit }, item) {
         commit("SET_ITEM_ISTRI", item);
      },
      resetItem({ commit }) {
         const item = { ...myModel };
         commit("SET_ITEM", item);
         commit("SET_ITEM_ISTRI", item);
         commit("SET_ITEM_SUAMI", item);
      },
      resetItemSuami({ commit }) {
         const item = { ...myModel };
         commit("SET_ITEM_SUAMI", item);
      },
      resetItemIstri({ commit }) {
         const item = { ...myModel };
         commit("SET_ITEM_ISTRI", item);
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data;
      },
      SET_ITEM(state, item) {
         state.item = item;
      },
      SET_ITEM_FORM(state, item) {
         item.profesi = createOptions(item.profesi);
         item.keterampilan = createOptions(item.keterampilan);
         item.peran_lingkungan = createOptions(item.peran_lingkungan);
         item.peran_masyarakat = createOptions(item.peran_masyarakat);
         item.peran_gereja = createOptions(item.peran_gereja);

         state.item = item;
      },
      SET_ITEM_SUAMI(state, item) {
         item.profesi = createOptions(item.profesi);
         item.keterampilan = createOptions(item.keterampilan);
         item.peran_lingkungan = createOptions(item.peran_lingkungan);
         item.peran_masyarakat = createOptions(item.peran_masyarakat);
         item.peran_gereja = createOptions(item.peran_gereja);

         state.suami = item;
      },
      SET_ITEM_ISTRI(state, item) {
         item.profesi = createOptions(item.profesi);
         item.keterampilan = createOptions(item.keterampilan);
         item.peran_lingkungan = createOptions(item.peran_lingkungan);
         item.peran_masyarakat = createOptions(item.peran_masyarakat);
         item.peran_gereja = createOptions(item.peran_gereja);

         state.istri = item;
      },
      PUSH_ITEM(state, item) {
         state.data.push(item);
      },
      CHANGE_ITEM(state, payload) {
         console.log(payload);
         const index = state.data.findIndex((item) => item.id === payload.id);
         if (index !== -1) {
            Vue.set(state.data, index, payload);
         }
      },
      REMOVE_ITEM(state, id) {
         var i = state.data.findIndex((data) => data.id == id);

         state.data.splice(i, 1);
      },
   },
};
